export const RequestsTabKeys = {
  ExportAndAccess: 'export-and-access',
  Export: 'export',
  DataAccess: 'data-access',
  Import: 'import'
} as const

export type RequestsTabKey = typeof RequestsTabKeys[keyof typeof RequestsTabKeys]

export enum ExportAndAccessSubTabKeys {
  Files = 'files',
  Analysis = 'analysis'
}

export const isRequestsTabKey = (value: string): value is RequestsTabKey => {
  return Object.values(RequestsTabKeys).includes(value as RequestsTabKey)
}

export const isExportAndAccessSubTabKey = (value: string): value is ExportAndAccessSubTabKeys => {
  return Object.values(ExportAndAccessSubTabKeys).includes(value as ExportAndAccessSubTabKeys)
}
